export default "__VITE_ASSET__DAzHvZTk__"